import * as React from "react";
import { singleton } from "logic/singleton";
const ReportPreviewContext = React.createContext(void 0);
export default singleton("contexts.ReportPreviewContext", () => ReportPreviewContext);
